import Vue from 'vue'
import VueResource from 'vue-resource';
import * as VueGoogleMaps from 'vue2-google-maps'

import StoreLocator from './components/store-locator.vue'
import StoreMap from './components/store-map.vue'
import store from './store'
import { sendEvent } from './analytics'

Vue.use(VueGoogleMaps, {
  load: {
    key: store.state.googleMapsApiKey,
    libraries: 'places',
  }
})

Vue.use(VueResource);

window.trackStorePageCall = function(storeId) {
  sendEvent("Store", "Call - store page", `${storeId}`)
}

document.addEventListener("DOMContentLoaded", function() {
  if (document.getElementById('store-map-app')) {
    new Vue({
      el: '#store-map-app',
      store,
      components: {
        'store-map': StoreMap,
      }
    })
  }

  if (document.getElementById('store-locator-app')) {
    new Vue({
      el: '#store-locator-app',
      store,
      components: {
        'store-locator': StoreLocator,
      }
    })
  }
})
